/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DownloadUrlResponseDto } from '../../models/download-url-response-dto';
import { RequestDownloadUrlDto } from '../../models/request-download-url-dto';

export interface MediaControllerGetDownloadUrl$Params {
      body: RequestDownloadUrlDto
}

export function mediaControllerGetDownloadUrl(http: HttpClient, rootUrl: string, params: MediaControllerGetDownloadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<DownloadUrlResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetDownloadUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DownloadUrlResponseDto>;
    })
  );
}

mediaControllerGetDownloadUrl.PATH = '/thalea-documents/download-url';
